import React from "react";
import styles from "./HelperCommentWildCardItem.module.scss";

const HelperCommentWildCardItem = ({ comment }) => (
	<div className={styles.container}>
		<p>{comment}</p>
	</div>
);

export default HelperCommentWildCardItem;